'use client';

import { locationApi, type Location } from '@/app/(modules)/robot-manager/_lib/api';
import { Badge } from '@/app/(modules)/robot-manager/_lib/SimpleListPage';
import { CrudListPage } from '@/app/(modules)/robot-manager/_lib/CrudListPage';

export default function LocationsAdminPage() {
  return (
    <CrudListPage<Location>
      title="位置"
      description="仓库 / 客户站点 / 工厂 / 保税区 / 服务中心 等地点主数据"
      api={locationApi}
      draftKey="platform-master:location"
      inlineEditFields={['enabled']}
      formFields={[
        { key: 'code', label: '编码', type: 'text', placeholder: '留空自动生成（L-时间戳）', createOnly: true },
        { key: 'name', label: '名称', type: 'text', required: true },
        {
          key: 'type',
          label: '类型',
          type: 'select',
          required: true,
          options: [
            { value: 'WAREHOUSE', label: '仓库' },
            { value: 'CUSTOMER_SITE', label: '客户站点' },
            { value: 'FACTORY', label: '工厂' },
            { value: 'BONDED_ZONE', label: '保税区' },
            { value: 'IN_TRANSIT', label: '在途' },
            { value: 'SERVICE_CENTER', label: '服务中心' },
          ],
        },
        { key: 'countryCode', label: '国家代码', type: 'text' },
        { key: 'address', label: '地址', type: 'textarea' },
        { key: 'enabled', label: '启用', type: 'boolean', defaultValue: true },
      ]}
      columns={[
        { key: 'code', label: '编码', width: '160px' },
        { key: 'name', label: '名称' },
        { key: 'type', label: '类型', width: '140px', render: (l) => <Badge text={l.type} /> },
        { key: 'countryCode', label: '国家', width: '80px' },
        { key: 'address', label: '地址' },
        { key: 'enabled', label: '启用', width: '80px', render: (l) => (l.enabled ? '✓' : '✗') },
      ]}
    />
  );
}
